import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import {
  GET_ACCOUNT,
  DELETE_ACCOUNT,
  SAVE_ACCOUNT,
} from "../../../helpers/url_api_constant";

import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  Button,
  FormGroup,
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Modal,
  Row,
  Table,
  Input,
} from "reactstrap";
import ConfirmDialog, {
  useConfirmDialog,
} from "../../../components/Custom/ConfirmDialog";
import MessageDialog, {
  useModalShowMessage,
} from "../../../components/Custom/MessageDialog";
import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import Loading from "../../../components/Custom/Loading";
import OverButton from "../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { post } from "../../../helpers/api_helper";
//i18n
import { withTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import Select from "react-select";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";

function UserManagement(props) {
  const permission = getPermission();

  const searchObj = { LOGIN_NAME: "", DISPLAY_NAME: "", UNITNAME: "", ROLE_OPERATOR: true, ROLE_MASTER_ADMIN: true, ROLE_SYSTEM_ADMIN: true, ROLE_USER_ADMIN: true, ROLE_VIEWER_REPORT: false };
  const createObj = {
    PID: "", LOGIN_NAME: "", FIRST_NAME: "", UNITNAME: "", ROLE_VIEW: false, ROLE_OPERATOR: false, ROLE_MASTER_ADMIN: false, ROLE_SYSTEM_ADMIN: false, ROLE_USER_ADMIN: false,
    ROLE_VIEWER_REPORT: false
  };

  const [readonly, setReadonly] = useState(false)
  const [pageAdd, setPageAdd] = useState(false);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);

  // const [listRole, setListRole] = useState([]);
  const [dropDownSearchRole, setDropDownSearchRole] = useState([]);

  const [userActionType, setUserActionType] = useState("");
  const [openPass, setOpenPass] = useState("password");

  const [isLoading, setIsLoading] = useState(false);
  const {
    showMessage,
    toggleModalMessage,
    bodyMessageModal,
    titleMessageModal,
  } = useModalShowMessage();
  const { showConfirm, toggleConfirm, messageConfirm } = useConfirmDialog();

  //ฝั่งซ้ายคือ ตัวแปล ฝั่งขวา คือ ฟังก์ชั่น Ex  modelDeviceList เป็น ตัวแปลที่ใช้ ส่วน  setModelDeviceListเป็น ฟังก์ชั่นที่ใช้ Set Value ให้ modelDeviceList

  const listRole = [{ label: "Operator", value: "Operator" }, { label: "Master Data", value: "Master Data" }, { label: "System Admin", value: "System Admin" }, { label: "User Admin", value: "User Admin" },
  { label: "Report Viewer", value: "Report Viewer" }];
  const listData = [
    {
      PID: 1,
      ID: "550159",
      USER_NAME: "Worapon",
      DIVISION: "บค.",
      VIEWER: 1,
      OPERATOR: 1,
      MASTER_DATA: 1,
      SYSTEM: 0,
      USER_ADMIN: 1,
    },
    {
      PID: 2,
      ID: "605864",
      USER_NAME: "Atibet",
      DIVISION: "คป.",
      VIEWER: 1,
      OPERATOR: 1,
      MASTER_DATA: 0,
      SYSTEM: 1,
      USER_ADMIN: 0,
    },
    {
      PID: 3,
      ID: "561528",
      USER_NAME: "Adithep",
      DIVISION: "ปร.",
      VIEWER: 1,
      OPERATOR: 0,
      MASTER_DATA: 1,
      SYSTEM: 0,
      USER_ADMIN: 0,
    },
  ];

  //sort Column//
  const defaultSorted = [
    {
      dataField: "PID",
      order: "asc",
    },
  ];
  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "250",
        value: 250,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };
  //Sort Page//

  const SelectStyle = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      ...isFocused && ({ backgroundColor: '#2E3460' })
    }),
  }

  // Action Button//
  const ButtonAction = (cellContent, row) => {
    return (
      <div className="d-sm-flex align-items-center justify-content-center">
        {/* <OverButton
          onClick={() => {
            setReadonly(true);
            onEdit(row);
            setUserActionType("(View)");
          }}
          color="primary"
          icon="fas fa-eye"
          label="View"
        /> */}
        {permission.eUSM && (
          <OverButton
            onClick={() => {
              setReadonly(false);
              onEdit(row);
              setUserActionType("(Edit)");
            }}
            color="info"
            icon="far fa-edit"
            label="Edit"
          />
        )}
        {/* <OverButton
          onClick={() => {
            onDelete(row);
          }}
          color="danger"
          icon="fas fa-trash-alt"
          label="Delete"
          disabled
        /> */}
      </div>
    );
  };
  // Action Button//

  const handleSelectDropDownSearchRole = selected => {
    // console.log(selected);
    setDropDownSearchRole(selected);
  };

  const checkFlagViewer = (cellContent, row) => {
    let icon;
    let color;

    if (row.ROLE_VIEW == true) {
      icon = "mdi mdi-check-bold fa-lg"
      color = "#5FBB44"
    } else {
      icon = "mdi mdi-close-thick fa-lg"
      color = "#f46a6a"
    }
    return (
      <div>
        <i className={icon} style={{ color: color }}></i>
      </div>
    );
  };

  // const checkFlagViewer = (cellContent, row) => {
  //   let icon;
  //   let color;

  //   if (row.ROLE_VIEW == true) {
  //     icon = "mdi mdi-check-bold fa-lg"
  //     color = "#5FBB44"
  //   } else {
  //     icon = "mdi mdi-close-thick fa-lg"
  //     color = "#f46a6a"
  //   }
  //   return (
  //     <div>
  //       <i className={icon} style={{ color: color }}></i>
  //     </div>
  //   );
  // };

  const checkFlagOperator = (cellContent, row) => {
    let icon;
    let color;

    if (row.ROLE_OPERATOR == true) {
      icon = "mdi mdi-check-bold fa-lg"
      color = "#5FBB44"
    } else {
      icon = "mdi mdi-close-thick fa-lg"
      color = "#f46a6a"
    }
    return (
      <div>
        <i className={icon} style={{ color: color }}></i>
      </div>
    );
  };

  const checkFlagMasterData = (cellContent, row) => {
    let icon;
    let color;

    if (row.ROLE_MASTER_ADMIN == true) {
      icon = "mdi mdi-check-bold fa-lg"
      color = "#5FBB44"
    } else {
      icon = "mdi mdi-close-thick fa-lg"
      color = "#f46a6a"
    }
    return (
      <div>
        <i className={icon} style={{ color: color }}></i>
      </div>
    );
  };

  const checkFlagSystem = (cellContent, row) => {
    let icon;
    let color;

    if (row.ROLE_SYSTEM_ADMIN == true) {
      icon = "mdi mdi-check-bold fa-lg"
      color = "#5FBB44"
    } else {
      icon = "mdi mdi-close-thick fa-lg"
      color = "#f46a6a"
    }
    return (
      <div>
        <i className={icon} style={{ color: color }}></i>
      </div>
    );
  };

  const checkFlagUserAdmin = (cellContent, row) => {
    let icon;
    let color;

    if (row.ROLE_USER_ADMIN == true) {
      icon = "mdi mdi-check-bold fa-lg"
      color = "#5FBB44"
    } else {
      icon = "mdi mdi-close-thick fa-lg"
      color = "#f46a6a"
    }
    return (
      <div>
        <i className={icon} style={{ color: color }}></i>
      </div>
    );
  };

  const checkFlagViewerReport = (cellContent, row) => {
    let icon;
    let color;

    if (row.ROLE_VIEWER_REPORT == true) {
      icon = "mdi mdi-check-bold fa-lg"
      color = "#5FBB44"
    } else {
      icon = "mdi mdi-close-thick fa-lg"
      color = "#f46a6a"
    }
    return (
      <div>
        <i className={icon} style={{ color: color }}></i>
      </div>
    );
  };

  const SumNameAndLastName = (cellContent, row) => {
    let text = row.FIRST_NAME + " " + row.LAST_NAME;
    return (
      <div>
        <span>{text}</span>
      </div>
    );
  };

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = 'white';

    return style;
  };

  //headerColumn
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      formatter: CountIndexRow,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
    },
    {
      dataField: "LOGIN_NAME",
      text: "ID",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "DISPLAY_NAME",
      text: "User Name",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "12px",
      },
      style: {
        width: "15%",
        fontSize: "12px",
      },
      sort: true,
      // isDummyField: true,
      // formatter: SumNameAndLastName,
    },
    {
      dataField: "UNITNAME",
      text: "Division",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "12px",
      },
      style: {
        width: "15%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "ROLE_VIEW",
      text: "Viewer",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "8%",
        fontSize: "12px",
      },
      style: {
        width: "8%",
        fontSize: "12px",
      },
      sort: false,
      isDummyField: true,
      formatter: checkFlagViewer,
    },
    {
      dataField: "ROLE_VIEWER_REPORT",
      text: "Report Viewer",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: false,
      isDummyField: true,
      formatter: checkFlagViewerReport,
    },
    {
      dataField: "ROLE_OPERATOR",
      text: "Operator",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "8%",
        fontSize: "12px",
      },
      style: {
        width: "8%",
        fontSize: "12px",
      },
      sort: false,
      isDummyField: true,
      formatter: checkFlagOperator,
    },
    {
      dataField: "ROLE_MASTER_ADMIN",
      text: "Master Data",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "8%",
        fontSize: "12px",
      },
      style: {
        width: "8%",
        fontSize: "12px",
      },
      sort: false,
      isDummyField: true,
      formatter: checkFlagMasterData,
    },
    {
      dataField: "ROLE_SYSTEM_ADMIN",
      text: "System Admin",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "8%",
        fontSize: "12px",
      },
      style: {
        width: "8%",
        fontSize: "12px",
      },
      sort: false,
      isDummyField: true,
      formatter: checkFlagSystem,
    },
    {
      dataField: "ROLE_USER_ADMIN",
      text: "User Admin",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "8%",
        fontSize: "12px",
      },
      style: {
        width: "8%",
        fontSize: "12px",
      },
      sort: false,
      isDummyField: true,
      formatter: checkFlagUserAdmin,
    },
    {
      dataField: "df1",
      text: "Action",
      headerAlign: "center",
      isDummyField: true,
      formatter: ButtonAction,
      // headerAlign: "center",
      // align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
    },
  ];
  //headerColumn

  //onInit//
  useEffect(function () {
    //userEffect คือทำงานคล้ายๆ onInIt หมายถึงว่า พอมีการเรียกเข้า การใช้งานใน Component นี้จะทำอันนี้เป็นอันแรก//
    resetSearch();
    resetModel();
    // setModelDeviceList(listData);

    ///fixed header table
    let tableId = "user-management-table";
    let scrollY = 265;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        if (tr) {
          for (var i = 0; i < tr.childNodes.length; i++) {
            th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };
  }, []);
  //onInit//


  useEffect(function () {
    setSearchModel(preVent => ({
      ...preVent,
      ROLE_OPERATOR: dropDownSearchRole.some((item) => item.label == "Operator"),
      ROLE_MASTER_ADMIN: dropDownSearchRole.some((item) => item.label == "Master Data"),
      ROLE_SYSTEM_ADMIN: dropDownSearchRole.some((item) => item.label == "System Admin"),
      ROLE_USER_ADMIN: dropDownSearchRole.some((item) => item.label == "User Admin"),
      ROLE_VIEWER_REPORT: dropDownSearchRole.some((item) => item.label == "Report Viewer"),
    }));
  }, [dropDownSearchRole,]);

  //Function CURL 
  const resetSearch = () => {
    setSearchModel(searchObj);
    fetchData(searchObj);
    setDropDownSearchRole(listRole.filter((obj) => obj.label == "Operator" || obj.label == "Master Data" || obj.label == "System Admin" || obj.label == "User Admin"));
  };

  const resetModel = () => {
    setCreateModel(createObj);
  };

  const onSearch = () => {
    fetchData(searchModel);
  };

  const onAdd = () => {
    // setOpenPass("password");
    setReadonly(false);
    resetModel();
    setPageAdd(true);
    setUserActionType("(Add Record)");
  };

  const onEdit = row => {
    // console.log(row);
    setCreateModel(row);
    setPageAdd(true);
  };

  const onDelete = row => {
    setCreateModel(row);
    toggleConfirm("Do you want to delete ?");
  };

  const validateForm = () => {
    let bResult = true;
    // if (createModel.ALIAS_NAME == "") {
    //   bResult = false;
    // }
    return bResult;
  };


  const fetchData = async (searchData) => {
    // setModelDeviceList(listData);
    setIsLoading(true);
    try {
      let res = await post(GET_ACCOUNT, searchData);
      // console.log(res);
      setModelDeviceList(res.data.AccountList);
    } catch (err) {
      toggleModalMessage(err.message);
    }
    setIsLoading(false);
  };

  const saveData = async () => {
    if (validateForm()) {
      setIsLoading(true);
      try {
        let res = await post(SAVE_ACCOUNT, createModel);
        // console.log(res);
        if (res.resultCode == 200) {
          res.isEditMode == 0 ? toggleModalMessage("Save success.") : toggleModalMessage("Update success.");
          setPageAdd(false);
          fetchData(searchModel);
        } else {
          toggleModalMessage(res.resultDescription);
        }
      } catch (err) {
        toggleModalMessage(err.message);
      }
      setIsLoading(false);
    }
  };

  const deleteData = async () => {
    setIsLoading(true);
    try {
      let res = await post(DELETE_ACCOUNT, createModel);
      toggleConfirm();
      if (res.resultCode == 200) {
        toggleModalMessage("Delete Success.");
        fetchData(searchModel);
      } else {
        toggleModalMessage(res.resultDescription);
      }
      setIsLoading(false);
    } catch (err) {
      toggleConfirm();
      toggleModalMessage(err.message);
      setIsLoading(false);
    }
  };

  //Function CURL
  function RenderList(prop) {
    // console.log(prop);
    return (
      <tr>
        <td className="text-center">{prop.indexlist}</td>
        <td className="text-center">{prop.data.Area}</td>
        <td className="text-center">
          <Button
            className="me-1 text-center"
            onClick={() => setPageAdd(true)}
            color="info"
          >
            <i className="far fa-edit"></i>
            &nbsp; Edit
          </Button>
          <Button
            onClick={() => setModalDelete(true)}
            // className="btn-rounded"
            color="danger"
          >
            <i className="fas fa-trash-alt"></i>
            &nbsp; Delete
          </Button>
        </td>
      </tr>
    );
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                    <h1 className="mb-sm-0 font-size-20"> {props.t("User Management")}</h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            User Management
                          </Link>
                        </li>

                        <li className="breadcrumb-item active">User Management</li>
                      </ol>
                    </div>
                  </div>
                  <hr />
                  <Row>
                    <Col sm="5">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          ID
                        </Label>
                        <Col sm={8}>
                          <div className="search-box">
                            <div className="position-relative">
                              <input
                                type="text"
                                // style={{backgroundColor:"#FFFFFF"}}
                                className="form-control rounded-2 basicborder"
                                placeholder={props.t("Search ID")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    LOGIN_NAME: e.target.value,
                                  })
                                }
                                value={searchModel.LOGIN_NAME}
                              />
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="5">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          User Name
                        </Label>
                        <Col sm={8}>
                          <div className="search-box">
                            <div className="position-relative">
                              <input
                                type="text"
                                // style={{backgroundColor:"#FFFFFF"}}
                                className="form-control rounded-2 basicborder"
                                placeholder={props.t("Search User Name")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    DISPLAY_NAME: e.target.value,
                                  })
                                }
                                value={searchModel.DISPLAY_NAME}
                              />
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="5">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Division
                        </Label>
                        <Col sm={8}>
                          <div className="search-box">
                            <div className="position-relative">
                              <input
                                type="text"
                                // style={{backgroundColor:"#FFFFFF"}}
                                className="form-control rounded-2 basicborder"
                                placeholder={props.t("Search Division")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    UNITNAME: e.target.value,
                                  })
                                }
                                value={searchModel.UNITNAME}
                              />
                              {/* {props.t("Search Meter Point ID") + "..."} */}
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="5">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Role
                        </Label>
                        <Col sm={8}>
                          <Select
                            value={dropDownSearchRole}
                            placeholder="( Blank )"
                            isMulti={true}
                            // isDisabled={readonly}
                            onChange={handleSelectDropDownSearchRole}
                            options={listRole}
                            classNamePrefix="select2-selection"
                            styles={SelectStyle}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="mb-2 mt-1">
                    <Col sm={12} className="d-flex align-items-center justify-content-end">
                      <div className="d-grid gap-2 d-md-block">
                        <Button
                          color="info"
                          className="mt-0 mb-0"
                          onClick={() => onSearch()}>
                          <i className="fas fa-search"></i>
                          &nbsp; Search
                        </Button>

                        <Button
                          color="warning"
                          className="mt-0 ms-2 mb-0"
                          onClick={() => resetSearch()}>
                          <i className="fas fa-redo-alt"></i>
                          &nbsp; Reset
                        </Button>
                      </div>
                    </Col>
                    {/* <Col sm="3">
                      <div className="d-grid gap-0 d-md-block">
                        <Button
                          onClick={() => onAdd()}
                          // className="btn-rounded"
                          color="success"
                          className="mt-4 mb-2"
                        >
                          <i className="fas fa-plus"></i>
                          &nbsp; Add
                        </Button>
                      </div>
                    </Col> */}
                  </Row>
                  <Row>
                    <Col sm="12">
                      <div>
                        {/* แบบเดิมใน div ใช้ ClassName นี้ className="table-responsive" */}
                        <BootstrapTable
                          id="user-management-table"
                          keyField="PID"
                          data={modelDeviceList}
                          columns={columns}
                          headerClasses="header-style"
                          rowStyle={rowStyleFontWhite}
                          defaultSorted={defaultSorted}
                          pagination={paginationFactory(options)}
                        // hover
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/*start : ModalPageAdd */}
      <Modal size="lg" isOpen={pageAdd}>
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            User Account {userActionType}
          </h5>
        </div>
        <div className="modal-body">

          <CardBody>
            <AvForm className="needs-validation">
              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center"
                  >
                    {/* <span style={{ color: "#FF0E03" }}>* </span> */}
                    ID
                  </Label>
                  <Col sm={8}>
                    <Input
                      // disabled={readonly}
                      // name="ALIAS_NAME"
                      type="text"
                      // errorMessage="Enter Shipper Name"
                      className="form-control basicborder"
                      // validate={{ required: { value: true } }}
                      disabled
                      onChange={e =>
                        setCreateModel({
                          ...createModel,
                          LOGIN_NAME: e.target.value,
                        })
                      }
                      value={createModel.LOGIN_NAME}
                    />
                  </Col>
                </FormGroup>
              </Row>
              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center"
                  >
                    {/* <span style={{ color: "#FF0E03" }}>* </span> */}
                    User Name
                  </Label>
                  <Col sm={8}>
                    <Input
                      // disabled={readonly}
                      // name="ALIAS_NAME"
                      type="text"
                      // errorMessage="Enter Shipper Name"
                      className="form-control basicborder"
                      // validate={{ required: { value: true } }}
                      disabled
                      onChange={e =>
                        setCreateModel({
                          ...createModel,
                          DISPLAY_NAME: e.target.value,
                        })
                      }
                      value={createModel.DISPLAY_NAME}
                    />
                  </Col>
                </FormGroup>
              </Row>

              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center"
                  >
                    {/* <span style={{ color: "#FF0E03" }}>* </span> */}
                    Division
                  </Label>
                  <Col sm={8}>
                    <Input
                      // disabled={readonly}
                      // name="ALIAS_NAME"
                      type="text"
                      // errorMessage="Enter Shipper Name"
                      className="form-control basicborder"
                      // validate={{ required: { value: true } }}
                      disabled
                      onChange={e =>
                        setCreateModel({
                          ...createModel,
                          UNITNAME: e.target.value,
                        })
                      }
                      value={createModel.UNITNAME}
                    />
                  </Col>
                </FormGroup>
              </Row>

              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center"
                  >
                  </Label>
                  <Col sm={3}>
                    <div className="mt-2 form-check form-check-outline form-check-primary">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={createModel.ROLE_VIEW}
                        id="checkViewer"
                        onChange={e => {
                          setCreateModel({
                            ...createModel,
                            ROLE_VIEW: e.target.checked,
                          })
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="checkViewer"
                      >
                        Viewer
                      </label>
                    </div>
                  </Col>
                  <Col sm={3}>
                    <div className="mt-2 form-check form-check-outline form-check-primary">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={createModel.ROLE_OPERATOR}
                        id="checkOperator"
                        onChange={e => {
                          setCreateModel({
                            ...createModel,
                            ROLE_OPERATOR: e.target.checked,
                          })
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="checkOperator"
                      >
                        Operator
                      </label>
                    </div>
                  </Col>
                  <Col sm={3}>
                    <div className="mt-2 form-check form-check-outline form-check-primary">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={createModel.ROLE_MASTER_ADMIN}
                        id="checkMasterData"
                        onChange={e => {
                          setCreateModel({
                            ...createModel,
                            ROLE_MASTER_ADMIN: e.target.checked,
                          })
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="checkMasterData"
                      >
                        Master Data
                      </label>
                    </div>
                  </Col>
                </FormGroup>
              </Row>

              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center"
                  >
                  </Label>

                  <Col sm={3}>
                    <div className="mt-2 form-check form-check-outline form-check-primary">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={createModel.ROLE_SYSTEM_ADMIN}
                        id="checkSystem"
                        onChange={e => {
                          setCreateModel({
                            ...createModel,
                            ROLE_SYSTEM_ADMIN: e.target.checked,
                          })
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="checkSystem"
                      >
                        System Admin
                      </label>
                    </div>
                  </Col>
                  <Col sm={3}>
                    <div className="mt-2 form-check form-check-outline form-check-primary">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={createModel.ROLE_USER_ADMIN}
                        id="checkUserAdmin"
                        onChange={e => {
                          setCreateModel({
                            ...createModel,
                            ROLE_USER_ADMIN: e.target.checked,
                          })
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="checkUserAdmin"
                      >
                        User Admin
                      </label>
                    </div>
                  </Col>
                  <Col sm={3}>
                    <div className="mt-2 form-check form-check-outline form-check-primary">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={createModel.ROLE_VIEWER_REPORT}
                        id="checkReportViewer"
                        onChange={e => {
                          setCreateModel({
                            ...createModel,
                            ROLE_VIEWER_REPORT: e.target.checked,
                          })
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="checkReportViewer"
                      >
                        Report Viewer
                      </label>
                    </div>
                  </Col>
                </FormGroup>
              </Row>


              <div className="text-center mt-2">
                {!readonly &&
                  <button
                    type="submit"
                    className="btn btn-success me-2"
                    onClick={() => saveData()}
                  >
                    <i className="far fa-save"></i> Save
                  </button>
                }
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setPageAdd(false)}
                >
                  <i className="fas fa-times"></i> Close
                </button>
              </div>
            </AvForm>
          </CardBody>
          {createModel.PID && (
            <Row className="mt-2">
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-start"
                  style={{ color: "#556ee6" }}
                >
                  Create By : {createModel.CREATE_USER} (  {moment(createModel.CREATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )
                </span>
              </Col>
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-end"
                  style={{ color: "#556ee6" }}
                >
                  Update By :  {createModel.UPDATE_USER} (  {moment(createModel.UPDATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )

                </span>
              </Col>
            </Row>
          )}
        </div>
        {/* -- Model Footer-- */}
        {/* <div className="modal-footer">
                <button type="button" className="btn btn-success">Save</button>
                <button type="button" className="btn btn-light" onClick={() =>
                  this.setState({ modal_backdrop: false })
                }>Close</button>
              </div> */}
        {/* -- Model Footer-- */}
      </Modal>
      {/*end : PageAdd */}

      {/*Loading */}
      <Loading show={isLoading} />
      {/*Loading */}

      {/* MessageDialog */}
      <MessageDialog
        isOpen={showMessage}
        hide={toggleModalMessage}
        title={titleMessageModal}
        message={bodyMessageModal}
      />
      {/* comfirmDialog */}
      <ConfirmDialog
        isOpen={showConfirm}
        hide={toggleConfirm}
        message={messageConfirm}
        onConfirm={deleteData}
      />

    </React.Fragment>
  );
}

UserManagement.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ UserManagement }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(UserManagement));

// ตัวอย่าง ที่1 เรียกหน้าแบบง่ายๆ Comment 2021-09-13//
// const Meter = () => {
//   return (
//     <React.Fragment>
//     <div className="page-content">
//       <Container fluid>
//         <h2>write Html code or structure</h2>
//       </Container>
//     </div>
//     </React.Fragment>
//   )
// }
// export default Meter;
// ตัวอย่าง ที่1 เรียกหน้าแบบง่ายๆ Comment 2021-09-13//

// ตัวอย่าง Table แบบเก่า
{
  /* <Table className="table table-bordered mb-0">
<thead className="table-light">
  <tr>
    <th className="text-center">No.</th>
    <th className="text-center">Customer</th>
    <th className="text-center">Action</th>
  </tr>
</thead>
<tbody>
  {modelDeviceList.map((value, index) => (<RenderList key={index} data={value} indexlist={index + 1} />))}
</tbody>

</Table>
<br></br>
<nav aria-label="Page navigation example">
<ul className="pagination justify-content-end">
  <li className="page-item disabled">
    <a className="page-link">Previous</a>
  </li>
  <li className="page-item active">
    <a className="page-link">1</a>
  </li>
  <li className="page-item disabled">
    <a className="page-link">Next</a>
  </li>
</ul>
</nav> */
}
